import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Card, MoneyValue } from '../../../../../../component';
import { Flex, Text } from '@mantine/core';
import { useWindowSize } from '../../../../../../hooks';
import withStoreProvider from '../../../../../../util/withStoreProvider';
import {
  useVoucherStateStore,
  VoucherStateStore,
  VoucherStateStoreProvider,
} from '../../../questionnaires/stores/VoucherStateStore';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../../../../route/Routes';
import { useEffect } from 'react';

export const QuestionnaireAndVoucherContent = observer(() => {
  const store = useVoucherStateStore();
  const { t } = useTranslation('homescreen');
  const isSmallScreen = useWindowSize(1100);
  const navigate = useNavigate();

  useEffect(() => {
    store.loadVoucherStates();

    return () => {
      store.resetStore();
    };
  }, [store]);

  return (
    <Card
      size="small"
      style={{ height: '100%', cursor: 'pointer' }}
      onClick={() => navigate(Routes.Questionnaires)}
    >
      <Flex
        direction={isSmallScreen ? 'column' : 'row'}
        wrap="wrap"
        gap="16px"
        justify="space-between"
        h="100%"
      >
        <Text fw="700" lh="24px" size="16px">
          {t('QuestionnaireAndVoucher.Title')}
        </Text>
        <MoneyValue money={store.availableToBeRedeemedAmount} isAvailable />
      </Flex>
    </Card>
  );
});

export const QuestionnaireAndVoucherCard = withStoreProvider(
  new VoucherStateStore(),
  VoucherStateStoreProvider,
)(QuestionnaireAndVoucherContent);
